/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Filter_TeamInputs */

const cs_reports_filter_team = /** @type {(inputs: Reports_Filter_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým`)
};

const en_reports_filter_team = /** @type {(inputs: Reports_Filter_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Reports_Filter_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_filter_team = /** @type {((inputs?: Reports_Filter_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Filter_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_filter_team(inputs)
	return cs_reports_filter_team(inputs)
});